import { useState, useEffect } from "react";
import api from "../services/api";

export interface MarketStatus {
  symbol: string;
  currentPrice: number;
  ema200: number;
  isBearish: boolean;
  changePercent: number;
  lastUpdated: Date;
  dataHealth: {
    isStale: boolean;
    lastDataDate: string | null;
  };
}

export function useMarketStatus() {
  const [marketStatus, setMarketStatus] = useState<MarketStatus | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchStatus = async () => {
    try {
      const res = await api.get("/scanner/market-status");
      setMarketStatus(res.data);
    } catch (err) {
      console.error("Failed to fetch market status", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatus();
    // Refresh every 15 mins (matching backend cache)
    const interval = setInterval(fetchStatus, 15 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return { marketStatus, loading, refreshStatus: fetchStatus };
}
